import { ITagResult } from '../../../../../../httpClient/serverApi/types/IResponse';
import { IAnalyticsExtConnectionSettings } from '../../../../../../settings/types/ISiteSettingsForSiteAdmin';
import { TagRequest } from '../../../TagRequest';

export type IAddAnalyticsExtConnectionSettingsResult = ITagResult & IAnalyticsExtConnectionSettings;

export class AddAnalyticsExtConnectionSettingsRequest extends TagRequest<IAnalyticsExtConnectionSettings, IAddAnalyticsExtConnectionSettingsResult> {
  constructor(params: IAnalyticsExtConnectionSettings) {
    super('analyticsextensions', 'addAnalyticsExtensionsConnection', params);
  }
}
